// extracted by mini-css-extract-plugin
export default {"TwoDimsFeature":"wm_a bhy_b bhy_we"};